// components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (!token) return <Navigate to="/login" replace />;
  if (!allowedRoles.includes(role)) {
    // Redirect to appropriate dashboard based on role instead of login
    if (role === 'admin') {
      return <Navigate to="/admin/system" replace />;
    } else if (role === 'dispatch') {
      return <Navigate to="/dashboard/dispatch" replace />;
    } else if (role === 'professional' || role === 'listing_only') {
      return <Navigate to="/dashboard/accepted-jobs" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
